import React from 'react';

import { Modal, Button } from 'react-bootstrap';

const BaseModal = (props) => {

    const hasFooter = props.onCancel || props.onConfirm;

    const classes = `${!hasFooter ? 'modal-without-footer' : ''} ${props.class ? props.class : ''}`

    return (
        <Modal show={props.show}
            size={props.large ? 'lg' : props.extraLarge ? 'xl' : 'sm'}
            className={classes}
            animation={false}
            backdrop="static"
            keyboard={false}
            onHide={props.onHide ? props.onHide : () => { }}
        >
            <Modal.Header>
                <Modal.Title>{props.title}</Modal.Title>
                <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={() => props.onHide()}>
                    <span aria-hidden="true">&times;</span>
                </button>
            </Modal.Header>
            <Modal.Body>
                {props.children}
            </Modal.Body>
            {
                hasFooter &&
                <Modal.Footer>
                    {props.onCancel && <Button className="btn btn-secondary" onClick={() => props.onCancel()}>{props.onCancelText}</Button>}
                    {props.onConfirm && <Button className="btn btn-primary" onClick={() => props.onConfirm()}>{props.onConfirmText}</Button>}
                </Modal.Footer>
            }
        </Modal>
    );
};

export default BaseModal;